jQuery(document).ready(function ($) { // wait for document ready
    var controller = new ScrollMagic.Controller({});
    var scenes = [];
    var doit;
    window.onresize = function(){
        clearTimeout(doit);
        doit = setTimeout(setupTrustRegistrationPage, 100);
    };
    setupTrustRegistrationPage();
    function resetScrollMagic() {
        controller.destroy('reset');
        controller = null;
        $.each(scenes,function(k,scene) {
            scenes[k].destroy('reset');
            scenes[k] = null;
        });
        controller = new ScrollMagic.Controller({});
    }
    var curSize = '';
    function setupTrustRegistrationPage() {
        var windowWidth = $(window).width();
        var newSize = 'desktop';
        if (windowWidth <= 991) {
            newSize = 'mobile';
        }
        if (curSize == newSize)
            return true;

        curSize = newSize;
        resetScrollMagic();
        var cookieVal = read_cookie('notice-dismissed');
        if (curSize == 'mobile' && $('.page-template-services_trusts_registration').length) {

        }
        else if (curSize == 'desktop' && $('.page-template-services_trusts_registration').length) {
            var controller = new ScrollMagic.Controller({});
            var headerHeight = $('.page-header').outerHeight();
            var adminBarHeight = 0;
            if ($('#wpadminbar').length) {
                headerHeight += $('#wpadminbar').outerHeight();
                adminBarHeight += $('#wpadminbar').outerHeight();
            }
            if (cookieVal != 'dismissed') {
                scenes.push(new ScrollMagic.Scene({triggerElement: "#slide-b"})
                    // trigger animation by adding a css class
                    .setClassToggle($('.cta-floating')[0], "visible")
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));
            }
            else {
                delete_cookie('notice-dismissed');
            }
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide-a',
                duration: "200%",
                offset: -1 * headerHeight
            })
                .setPin('#slide-a', {pushFollowers: false})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide-b',
                duration: "150%",
                offset: -1 * headerHeight
            })
                .setPin('#slide-b', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide-c',
                duration: "50%",
                offset: -1 * headerHeight
            })
                .setPin('#slide-c', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: '#slide-a',
                offset: -1 * (headerHeight),
                triggerHook: 'onLeave',
                duration: function() {
                    return $('#slide-a').outerHeight();
                }
            })
                .setClassToggle($('#slide-a')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: '#slide-b',
                offset: -1 * (headerHeight),
                triggerHook: 'onLeave',
                duration: '300%'
            })
                .setClassToggle($('#slide-b')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));
        }
    }
});